import { Link } from "react-router-dom";

export const LegalNote = ({ className = "" }) => (
  <p className={`text-xs leading-relaxed text-[#5C6B61] border-t border-border pt-5 ${className}`} data-testid="legal-note">
    Informazione conforme alla legge sulla pubblicità sanitaria del 2018 (L. 145/2018). Listino visibile in studio.
    Direttori sanitari visibili nella sezione <Link to="/dove-siamo" className="underline font-semibold text-[#385244]">Dove siamo</Link> del sito.
  </p>
);
